import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { StatusChip } from "../../../shared/components/status-chip/StatusChip";
import { Button } from "../../../shared/components/buttons/Button";
import { useRelativeTime } from "../../../shared/hooks/useRelativeTime";
import { formatStatusReasons } from "../../../shared/utils/format-status-reasons";
import type { CampaignCardView } from "../../../shared/types/campaign-card.type";
import { useDashboardData } from "../../main/service/dashboard-data.service";

type Props = {
	campaign: CampaignCardView;
	onRefresh: () => void;
	isRefreshing?: boolean;
};

export const CampaignDetailHeader = ({
	campaign,
	onRefresh,
	isRefreshing,
}: Props) => {
	const navigate = useNavigate();
	const updatedAgo = useRelativeTime(campaign.lastUpdatedAt);
	const { data: dashboardData } = useDashboardData();
	const statusTooltip = useMemo(() => {
		const campaigns = dashboardData?.campaigns_info?.data ?? [];
		const match = campaigns.find(
			(item) => String(item.campaign_id) === campaign.campaignId,
		);
		return formatStatusReasons(match?.primary_status_reasons ?? []);
	}, [dashboardData, campaign.campaignId]);

	return (
		<header className='campaign-detail__header'>
			<button
				type='button'
				className='campaign-detail__back'
				onClick={() => navigate("/main")}>
				← Назад
			</button>
			<div className='campaign-detail__divider' />
			<div className='campaign-detail__avatar'>
				{campaign.name.slice(0, 1).toUpperCase()}
			</div>
			<div className='campaign-detail__title-block'>
				<h1 data-copyable>{campaign.name}</h1>
				<div className='campaign-detail__meta'>
					<StatusChip
						status={campaign.status}
						tooltip={statusTooltip || undefined}
					/>
					<span>{campaign.appId}</span>
					<span>· UAM: {campaign.uam}</span>
					{campaign.isRent && (
						<span className='campaign-detail__banner--rent'>RENTED</span>
					)}
				</div>
			</div>
			<div className='campaign-detail__header-actions'>
				<span style={{ fontSize: 11, color: "var(--secondary-text-color)" }}>
					Оновлено: {updatedAgo || "—"}
				</span>
				<Button
					onClick={onRefresh}
					unactive={isRefreshing}
					className='campaign-detail__refresh-btn'>
					Оновити
				</Button>
			</div>
		</header>
	);
};
